export class PublicFormToken {
    public id: number = -1;
    public token: string = '';
    public createdAt: string = '';
    public updatedAt: string = '';
}